import { action } from 'mobx';
import { ProductOrderingEditForm } from 'application/product-ordering/forms';
import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { applicationContext } from 'core/utils';
import { LookupService } from "common/services";
import { ProductService } from 'application/product/services';
import { ItemSubcategoryService } from "application/facility-order/services";

@applicationContext
class ProductOrderingViewStore extends BaseEditViewStore {

    constructor(rootStore) {
        const service = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        const productService = new ProductService(rootStore.application.baasic.apiClient);
        const lookupService = new LookupService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'product-ordering-edit',
            Form: ProductOrderingEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ProductOrderingEditForm,
        });

        this.productStore = new BaasicDropdownStore({
            filterable: true,
            textField: "description",
        }, {
            fetchFunc: async (term) => {
                const response = await productService.find({
                    sort: "itemId|asc",
                    searchQuery: term,
                    rpp: 100,
                    isActive: true
                });
                return response.data.item;
            }
        });

        this.subCategoryStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async () => {
                const response = await lookupService.getLookups('SubCategory');
                return response.subCategory;
            }
        });
    }

    @action.bound
    async onInit({ initialLoad }) {
        if (!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }

    @action.bound
    async createResource(resource, replace = false) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({ ...resource, replace: replace });

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            if (err && err.data && err.data.message && err.data.message != "Resource already exists.") {
                this.showConfirmModal(resource);
            }
            else {
                this.rootStore.notificationStore.error(`This item is already linked with this subcategory`);
            }
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('PRODUCT_ORDERING.CREATE.SUCCESS');
    }

    @action.bound
    showConfirmModal(resource) {
        this.rootStore.modalStore.showConfirm(
            `A product with sort number ${resource.sort} already exists. Do you want to replace it and readjust all subsequent sort numbers?`,
            async () => {
                this.createResource(resource, true);
            }
        );
    }
}

export default ProductOrderingViewStore;
